import actionNames from './actionNames'

const mutations = {
  action(state, action) {
    state.action = action

    if (action === 'read') {
      state.weekdate = null
    }
  },
  weekdate(state, weekdate) {
    state.weekdate = weekdate
  },

  entry(state, entry) {
    state.entry = entry
  },
  selected(state, selected) {
    state.selected = selected
  },

  timeShift(state, timeShift) {
    state.timeShift = timeShift
  },
  timeTypes(state, timeTypes) {
    state.timeTypes = timeTypes
  },

  organization(state, organization) {
    state.organization = organization
  },
  organizations(state, organizations) {
    state.organizations = organizations
  },

  person(state, person) {
    state.person = person
  },
  persons(state, persons) {
    state.persons = persons
  },

  project(state, project) {
    state.project = project
  },
  projects(state, projects) {
    state.projects = projects
  },

  isSettingsModalVisible(state, isSettingsModalVisible) {
    state.isSettingsModalVisible = isSettingsModalVisible
  },
  isOrganizationModalVisible(state, isOrganizationModalVisible) {
    state.isOrganizationModalVisible = isOrganizationModalVisible
  },
  isUserFormVisible(state, isUserFormVisible) {
    state.isUserFormVisible = isUserFormVisible
  },
  isProjectModalVisible(state, isProjectModalVisible) {
    state.isProjectModalVisible = isProjectModalVisible
  },
  isTimeModalVisible(state, isTimeModalVisible) {
    state.isTimeModalVisible = isTimeModalVisible
  },

  isLoadingInternal: (state, isLoadingInternal) => {
    state.isLoadingInternal = isLoadingInternal
  },
  didLoadInternalFail: (state, didLoadInternalFail) => {
    state.didLoadInternalFail = didLoadInternalFail
  },

  isLoadingOverview: (state, isLoadingOverview) => {
    state.isLoadingOverview = isLoadingOverview
  },
  didLoadOverviewFail: (state, didLoadOverviewFail) => {
    state.didLoadOverviewFail = didLoadOverviewFail
  },

  isLoadingTime: (state, isLoadingTime) => {
    state.isLoadingTime = isLoadingTime
  },
  didLoadTimeFail: (state, didLoadTimeFail) => {
    state.didLoadTimeFail = didLoadTimeFail
  },

  isLoadingPerson: (state, isLoadingPerson) => {
    state.isLoadingPerson = isLoadingPerson
  },
  didLoadPersonFail: (state, didLoadPersonFail) => {
    state.didLoadPersonFail = didLoadPersonFail
  },

  isLoadingOrganization: (state, isLoadingOrganization) => {
    state.isLoadingOrganization = isLoadingOrganization
  },
  didLoadOrganizationFail: (state, didLoadOrganizationFail) => {
    state.didLoadOrganizationFail = didLoadOrganizationFail
  },

  [actionNames.SHOW_INTERNAL_VIEW](state, status) {
    state.isLoadingInternal = false
    state.internalViewStatus = status
  },
  [actionNames.UNKNOWN_ERROR](state, error) {
    state.error = error
  },

  [actionNames.GET_INTERNAL_REQUESTED](state) {
    state.isLoadingInternals = true
    state.didLoadInternalsFail = false
  },
  [actionNames.GET_INTERNAL_SUCCEEDED](state, persons) {
    state.isLoadingInternals = false
    state.internals = persons
  },
  [actionNames.GET_INTERNAL_FAILED](state, error = true) {
    state.isLoadingInternals = false
    state.didLoadInternalsFail = error
  },

  [actionNames.ADD_INTERNAL_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.ADD_INTERNAL_SUCCEEDED](state, person) {
    state.isSubmitting = false
    state.internals = person
  },
  [actionNames.ADD_INTERNAL_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.EDIT_INTERNAL_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.EDIT_INTERNAL_SUCCEEDED](state, person) {
    state.isSubmitting = false
    state.internals = person
  },
  [actionNames.EDIT_INTERNAL_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.DELETE_INTERNAL_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.DELETE_INTERNAL_SUCCEEDED](state, person) {
    state.isSubmitting = false
    state.internals = person
  },
  [actionNames.DELETE_INTERNAL_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.GET_MANAGER_REQUESTED](state) {
    state.isLoadingManager = true
    state.didLoadManagerFail = false
    state.manager = null
  },
  [actionNames.GET_MANAGER_SUCCEEDED](state, manager) {
    state.isLoadingManager = false
    state.didLoadManagerFail = false
    state.manager = manager
  },
  [actionNames.GET_MANAGER_FAILED](state, error = true) {
    state.isLoadingManager = false
    state.didLoadManagerFail = error
    state.manager = null
  },

  [actionNames.GET_PERSON_REQUESTED](state) {
    state.isLoadingPerson = true
    state.didLoadPersonFail = false
  },
  [actionNames.GET_PERSON_SUCCEEDED](state, person) {
    state.isLoadingPerson = false
    state.person = person
  },
  [actionNames.GET_PERSON_FAILED](state, error = true) {
    state.isLoadingPerson = false
    state.didLoadPersonFail = error
  },

  [actionNames.ADD_PERSON_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.ADD_PERSON_SUCCEEDED](state, person) {
    state.isSubmitting = false
    state.person = person
  },
  [actionNames.ADD_PERSON_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.EDIT_PERSON_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.EDIT_PERSON_SUCCEEDED](state, person) {
    state.isSubmitting = false
    state.person = person
  },
  [actionNames.EDIT_PERSON_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.DELETE_PERSON_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.DELETE_PERSON_SUCCEEDED](state, person) {
    state.isSubmitting = false
    state.person = person
  },
  [actionNames.DELETE_PERSON_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  // @TODO Rename internal store actions for GET_PUBLISHERS to GET_NETWORKS
  [actionNames.GET_PUBLISHER_REQUESTED](state) {
    state.isLoadingPublisher = true
    state.didLoadPublisher = false
  },
  [actionNames.GET_PUBLISHER_SUCCEEDED](state, publisher) {
    state.isLoadingPublisher = false
    state.publisher = publisher
  },
  [actionNames.GET_PUBLISHER_FAILED](state, error = true) {
    state.isLoadingPublisher = false
    state.didLoadPublisherFail = error
  },

  [actionNames.GET_PUBLISHERS_REQUESTED](state) {
    state.isLoadingPublishers = true
    state.didLoadPublishers = false
  },
  [actionNames.GET_PUBLISHERS_SUCCEEDED](state, publishers) {
    state.isLoadingPublishers = false
    state.publishers = publishers
  },
  [actionNames.GET_PUBLISHERS_FAILED](state, error = true) {
    state.isLoadingPublishers = false
    state.didLoadPublishersFail = error
  },

  [actionNames.GET_CLIENTS_REQUESTED](state) {
    state.isLoadingClients = true
    state.didLoadClientsFail = false
  },
  [actionNames.GET_CLIENTS_SUCCEEDED](state, clients) {
    state.isLoadingClients = false
    state.clients = clients
  },
  [actionNames.GET_CLIENTS_FAILED](state, error = true) {
    state.isLoadingClients = false
    state.didLoadClientsFail = error

    return error
  },

  [actionNames.GET_ORGANIZATION_REQUESTED](state) {
    state.isLoadingOrganization = true
    state.didLoadOrganizationFail = false
  },
  [actionNames.GET_ORGANIZATION_SUCCEEDED](state, organization) {
    state.isLoadingOrganization = false
    state.organization = organization
  },
  [actionNames.GET_ORGANIZATION_FAILED](state, error) {
    state.isLoadingOrganization = false
    state.didLoadOrganizationFail = error || true
  },

  [actionNames.GET_ORGANIZATIONS_REQUESTED](state) {
    state.isLoadingOrganization = true
    state.didLoadOrganizationFail = false
  },
  [actionNames.GET_ORGANIZATIONS_SUCCEEDED](state, organizations) {
    state.isLoadingOrganization = false
    state.organizations = organizations
  },
  [actionNames.GET_ORGANIZATIONS_FAILED](state, error = true) {
    state.isLoadingOrganization = false
    state.didLoadOrganizationFail = error
  },

  [actionNames.ADD_ORGANIZATION_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.ADD_ORGANIZATION_SUCCEEDED](state, organization) {
    state.isSubmitting = false
    state.organization = organization
  },
  [actionNames.ADD_ORGANIZATION_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.EDIT_ORGANIZATION_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.EDIT_ORGANIZATION_SUCCEEDED](state, organization) {
    state.isSubmitting = false
    state.organization = organization
  },
  [actionNames.EDIT_ORGANIZATION_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.DELETE_ORGANIZATION_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.DELETE_ORGANIZATION_SUCCEEDED](state, organization) {
    state.isSubmitting = false
    state.organization = organization
  },
  [actionNames.DELETE_ORGANIZATION_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.GET_PROJECTS_REQUESTED](state) {
    state.isLoadingProjects = true
    state.didLoadProjectsFail = false
  },
  [actionNames.GET_PROJECTS_SUCCEEDED](state, projects) {
    state.isLoadingProjects = false
    state.didLoadProjectsFail = false
    state.projects = projects
  },
  [actionNames.GET_PROJECTS_FAILED](state, error = true) {
    state.isLoadingProjects = false
    state.didLoadProjectsFail = error
    state.projects = null
  },

  [actionNames.GET_PROJECT_REQUESTED](state) {
    state.isLoadingProject = true
    state.didLoadProjectFail = false
  },
  [actionNames.GET_PROJECT_SUCCEEDED](state, project) {
    state.isLoadingProject = false
    state.didLoadProjectFail = false
    state.project = project
  },
  [actionNames.GET_PROJECT_FAILED](state, error = true) {
    state.isLoadingProject = false
    state.didLoadProjectFail = error
    state.project = null
  },

  [actionNames.ADD_PROJECT_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.ADD_PROJECT_SUCCEEDED](state, project) {
    state.isSubmitting = false
    state.project = project
  },
  [actionNames.ADD_PROJECT_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.EDIT_PROJECT_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.EDIT_PROJECT_SUCCEEDED](state, project) {
    state.isSubmitting = false
    state.project = project
  },
  [actionNames.EDIT_PROJECT_FAILED](state, error = true) {
    state.isSubmitting = false
    state.didActionFail = error
  },

  [actionNames.DELETE_PROJECT_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.DELETE_PROJECT_SUCCEEDED](state, project) {
    state.isSubmitting = false
    state.project = project
  },
  [actionNames.DELETE_PROJECT_FAILED](state) {
    state.isSubmitting = false
    state.didActionFail = true
  },

  [actionNames.GET_SERVICE_REQUESTED](state) {
    state.isLoadingService = true
    state.didLoadServiceFail = false
  },
  [actionNames.GET_SERVICE_SUCCEEDED](state, services) {
    state.isLoadingService = false
    state.services = services
  },
  [actionNames.GET_SERVICE_FAILED](state) {
    state.isLoadingService = false
    state.didLoadServiceFail = true
  },

  [actionNames.GET_TIMETYPE_REQUESTED](state) {
    state.isLoadingTimeTypes = true
    state.didLoadTimeTypesFail = false
  },
  [actionNames.GET_TIMETYPE_SUCCEEDED](state, timeTypes) {
    state.isLoadingTimeTypes = false
    state.timeTypes = timeTypes
  },
  [actionNames.GET_TIMETYPE_FAILED](state) {
    state.isLoadingTimeTypes = false
    state.didLoadTimeTypesFail = true
  },

  [actionNames.GET_WEEK_REQUESTED](state) {
    state.isLoadingWeek = true
    state.didLoadWeekFail = false
  },
  [actionNames.GET_WEEK_SUCCEEDED](state, week) {
    state.isLoadingWeek = false
    state.week = week
  },
  [actionNames.GET_WEEK_FAILED](state) {
    state.isLoadingWeek = false
    state.didLoadWeekFail = true
  },

  [actionNames.GET_OVERVIEW_REQUESTED](state) {
    state.isLoadingOverview = true
    state.didLoadOverviewFail = false
  },
  [actionNames.GET_OVERVIEW_SUCCEEDED](state, { entries }) {
    state.isLoadingOverview = false
    state.entries = entries
  },
  [actionNames.GET_OVERVIEW_FAILED](state) {
    state.isLoadingOverview = false
    state.didLoadOverviewFail = true
  },

  [actionNames.GET_TIME_REQUESTED](state) {
    state.isLoadingTime = true
    state.didLoadTimeFail = false
  },
  [actionNames.GET_TIME_SUCCEEDED](state, entries) {
    state.isLoadingTime = false
    state.entries = entries
  },
  [actionNames.GET_TIME_FAILED](state) {
    state.isLoadingTime = false
    state.didLoadTimeFail = true
  },

  [actionNames.ADD_TIME_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.ADD_TIME_SUCCEEDED](state, entry) {
    state.isSubmitting = false
    state.entry = entry
  },
  [actionNames.ADD_TIME_FAILED](state) {
    state.isSubmitting = false
    state.didActionFail = true
  },

  [actionNames.EDIT_TIME_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.EDIT_TIME_SUCCEEDED](state, entry) {
    state.isSubmitting = false
    state.entry = entry
  },
  [actionNames.EDIT_TIME_FAILED](state) {
    state.isSubmitting = false
    state.didActionFail = true
  },

  [actionNames.DELETE_TIME_REQUESTED](state) {
    state.isSubmitting = true
    state.didActionFail = false
  },
  [actionNames.DELETE_TIME_SUCCEEDED](state, entry) {
    state.isSubmitting = false
    state.entry = entry
  },
  [actionNames.DELETE_TIME_FAILED](state) {
    state.isSubmitting = false
    state.didActionFail = true
  },
}

export default mutations
